module.exports = __webpack_public_path__ + "img/doc-push.20fc3d11.png";